import React, { useState } from "react";
import PropTypes from "prop-types";

import { Segment } from "semantic-ui-react";

import "./AddClientPopUp.css";

import Popper from "components/Popper";

import { AddClientButton } from "./components";

export function AddClientPopUp({ totalClient, ...props }) {
  const [popupOpen, setPopupOpen] = useState(false);
  const [addClientTooltipProps, setAddClientTooltipProps] = useState({});

  const onClearIconClicked = () => {
    setPopupOpen(false);
    setAddClientTooltipProps({});
  };

  const onAddClientButtonClicked = () => {
    setPopupOpen(true);
    setAddClientTooltipProps({ open: false });
  };

  if (totalClient === null) {
    return (
      <Segment style={{ width: "25%", textAlign: "center", padding: "0.75em" }}>
        <AddClientButton
          isOpen={popupOpen}
          onClose={onClearIconClicked}
          onClick={onAddClientButtonClicked}
          {...props}
        />
      </Segment>
    );
  }

  return (
    <Popper
      content="Add Client(s)"
      position="top center"
      on="hover"
      {...addClientTooltipProps}
      trigger={
        <Segment
          style={{ width: "25%", textAlign: "center", padding: "0.75em" }}
        >
          <AddClientButton
            isOpen={popupOpen}
            text={`${totalClient > 1000 ? "999+" : totalClient} Client${
              totalClient >= 1 ? "s" : ""
            }`}
            onClose={onClearIconClicked}
            onClick={onAddClientButtonClicked}
            {...props}
          />
        </Segment>
      }
    />
  );
}

AddClientPopUp.defaultProps = { totalClient: null };

AddClientPopUp.propTypes = {
  totalClient: PropTypes.number,
};

export default AddClientPopUp;
